import React from 'react';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { postData } from '../../functions/postData.js';
import Button from '@material-ui/core/Button'
import Icon from '@mdi/react';
import { mdiCloseBoxMultiple } from '@mdi/js';
import { _ } from '../../functions/translator.js';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { CircularProgress } from '@material-ui/core'
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { editCards, editFeaturesGroup, editFigures } from '../../actions/index';
import { CardsGroupStatus } from '../../constants/constants';

function MassClosing(props){
    const dispatch = useDispatch();
    const { selectedCardsGroups, projectData } = useSelector(state => ({
        selectedCardsGroups: state.selectedCardsGroups,
        projectData: state.projectData
    }))
    const [show, setShow] = useState(false);
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [showFailureToast, setShowFailureToast] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getClosableCardsGroupIds = () => {
        if (!selectedCardsGroups || !Array.isArray(selectedCardsGroups)) return [];
        
        return selectedCardsGroups.filter(id => {
            const cardsGroup = projectData?.cards_groups?.[id];
            if (!cardsGroup?.attributes) return false;
            
            const status = cardsGroup.attributes.status;
            return status !== CardsGroupStatus.CLOSED && status !== CardsGroupStatus.STAND_BY;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowLoading(true)
        try {
            const formData = new FormData(e.target);
            const closing_message = formData.get('closing_message');
            const searchParams = new URLSearchParams(window.location.search);
            const project_id = searchParams.get('project_id');

            const closableCardsGroupIds = getClosableCardsGroupIds();
            const urlPost = {
                cards_group_ids: closableCardsGroupIds,
                project_id,
                closing_message
            };
            
            const response = await postData('/web-api/close-cards-group', urlPost, 'Error en la solicitud');
            if (response.status === 'success') {
                // Recargar los cardsGroups cerrados
                const reloadProps = {
                    projectData,
                    editCards: (data) => dispatch(editCards(data)),
                    editFeaturesGroup: (data, levelId) => dispatch(editFeaturesGroup(data, levelId)),
                    editFigures: (figuresData, figuregroupsMap) => dispatch(editFigures(figuresData, figuregroupsMap))
                };
                
                setShowSuccessToast(true);
                reloadCardsGroupsFeatures(reloadProps, closableCardsGroupIds);
                setTimeout(() => {
                    handleClose();
                }, 4000);
            } else {
                setShowFailureToast(true);
            }

        } catch (error) {
            console.error('Error:', error);
            setShowFailureToast(true);
        } finally {
            setShowLoading(false)
        }
    };

    return(
        <>
            {props.popUpMenu === true ?
            <div className='w-100' onClick={handleShow}>
                <div className='d-inline-flex'>
                    <Icon path={ mdiCloseBoxMultiple } size='30px' color='white' style={{margin: 10}}/>
                    <p>{ _('Cierre Masivo') }</p>
                </div>
            </div>
            :<Button 
                onClick={handleShow} 
                size='small' 
                style={{width:'100%', background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700}}>
                <div className='d-flex flex-row'>
                    <Icon path={mdiCloseBoxMultiple} size={1} className='mr-2'/>
                    <p style={{fontFamily:'Rubik', margin:'0px'}}>{ _('Cierre Masivo') }</p>
                </div>
            </Button>}
            
            
            <Modal show={show} onHide={handleClose} className="fade" style={{fontFamily:"Rubik"}}>
                <Modal.Header>
                    <p style={{fontFamily:'Rubik' , margin:'0px', }}>{ _('Cierre Masivo') }</p>
                    <div className='close-button text-md' onClick={handleClose}>
                        x
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Snackbar 
                        className='w-100 p-0' 
                        onClose={() => setShowSuccessToast(false)} 
                        open={showSuccessToast} 
                        autoHideDuration={4000}>
                            <MuiAlert elevation={6} variant="filled" severity="success">
                                <div className='text-center w-100 m-0'>
                                    <p>¡{_('Se han cerrado')} {selectedCardsGroups.length} {_('registros exitosamente')}!</p>
                                </div>
                            </MuiAlert>
                    </Snackbar>
                    <Snackbar 
                        className='w-100 p-0' 
                        onClose={() => setShowFailureToast(false)} 
                        open={showFailureToast} 
                        autoHideDuration={4000}>
                            <MuiAlert elevation={6} variant="filled" severity="error">
                                <p className='text-center w-100 m-0'>¡{_('Ha ocurrido un error al cerrar los registros')}!</p>
                            </MuiAlert>
                    </Snackbar>
                    
                    <p>{_('Cerrarás masivamente los registros seleccionados')}:  {selectedCardsGroups.length}</p>
                    <Form method="POST" onSubmit={handleSubmit}>
                        
                        <Form.Group controlId="closing_message">
                            <Form.Label>{_('Mensaje de cierre')}:</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={3} 
                                placeholder={_('Ingrese el mensaje de cierre...')}
                                name="closing_message" 
                                required 
                            />
                        </Form.Group>

                        <div className='d-flex justify-content-center mt-3 mb-1'>
                            <div style={{ position: 'relative' }}>
                                <Button 
                                    size='small' 
                                    style={{ background:'#ff5300', color:"#ffffff", textTransform: 'none', fontWeight:700 }} 
                                    type="submit"
                                    disabled={showLoading}>
                                    <p style={{fontFamily:"Rubik", margin:'0px'}}>{ _('Cerrar Registros') }</p>
                                </Button>
                                {showLoading && 
                                    <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                        <CircularProgress style={{ width:'20px', height:'20px' }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MassClosing


